import React from 'react';
import PropTypes from 'prop-types';
import BillingForm from './form/BillingForm';
import UserProp from '../propTypes/userProp';
import translate from '../../../commonComponents/translate';
import TabbedPortlet from '../../../commonComponents/portlets/Tabbed/TabbedPortlet';
import Subscriptions from '../../subscriptionList/Subscriptions';
import Invoices from '../../invoicesList/Invoices';
import { PROFILE_TAB, PROFILE_TABS } from '../../../services/utilityFunctions';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import BillingProp from '../propTypes/billingProp';
import TaxIdTypeProp from '../../subscriptionDetails/propTypes/TaxIdTypeProp';
import BusinessTypeProp from '../propTypes/businessTypeProp';

function MainPanel(props) {
  const {
    t,
    activeTab,
    member,
    countries,
    billing,
    onBillingChange,
    taxIdTypes,
    businessTypes,
    languages,
  } = props;

  let tabs = [
    {
      id: 'billingTab',
      title: t('profile_tab_billing'),
      content: (
        <BillingForm
          countries={countries}
          billing={billing}
          onBillingChange={onBillingChange}
          taxIdTypes={taxIdTypes}
          businessTypes={businessTypes}
          languages={languages}
        />
      ),
    },
  ];
  if (member.role !== 'instance_admin') {
    tabs = tabs.concat([
      {
        id: 'subscriptionsTab',
        title: t('profile_tab_subscriptions'),
        content: <Subscriptions />,
      },
      {
        id: 'invoicesTab',
        title: t('profile_tab_invoices'),
        content: <Invoices />,
      },
    ]);
  }

  const selectedIndex = {
    [PROFILE_TAB.BILLING]: 1,
    [PROFILE_TAB.SUBSCRIPTIONS]: 2,
    [PROFILE_TAB.INVOICES]: 3,
  };
  const index = selectedIndex[activeTab];

  return (
    <TabbedPortlet
      selectedIndex={index}
      tabs={tabs}
      style={{ minHeight: 'calc(100vh - 240px)' }}
    />
  );
}

MainPanel.propTypes = {
  t: PropTypes.func.isRequired,
  activeTab: PropTypes.oneOf(PROFILE_TABS),
  member: PropTypes.shape(UserProp.propType).isRequired,
  billing: PropTypes.shape(BillingProp.propType).isRequired,
  onBillingChange: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  taxIdTypes: PropTypes.arrayOf(PropTypes.shape(TaxIdTypeProp.propType))
    .isRequired,
  businessTypes: PropTypes.arrayOf(PropTypes.shape(BusinessTypeProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
};

MainPanel.defaultProps = {
  activeTab: null,
};

export default translate(MainPanel);
